import React from "react";

const STEPS = [
  {
    num: "01",
    title: "Join the Waitlist",
    description: "Enter your name and email in seconds. No commitments, no spam.",
  },
  {
    num: "02",
    title: "Get Early Access",
    description: "Receive your launch notification along with Founding Member rewards.",
  },
  {
    num: "03",
    title: "Start Booking",
    description: "Browse, order, and enjoy — instantly. Welcome to the new way. Welcome to the Hyyve.",
  },
];

export default function HowItWorks() {
  return (
    <section id="how-it-works" data-testid="how-it-works-section" className="py-28 md:py-36 bg-bhyyve-subtle/40">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="max-w-2xl mb-20 lg:mb-28">
          <div className="text-sm tracking-wider uppercase font-semibold text-bhyyve-emerald mb-5">How It Works</div>
          <h2 className="font-heading text-5xl sm:text-6xl tracking-tight leading-[1.05] font-medium text-bhyyve-ink">
            Three steps. That's it.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 lg:gap-8 relative">
          {/* Connector line */}
          <div aria-hidden="true" className="hidden md:block absolute top-14 left-[16%] right-[16%] h-px bg-gradient-to-r from-transparent via-bhyyve-honey/40 to-transparent" />

          {STEPS.map((step, i) => (
            <div key={i} data-testid={`step-card-${i}`} className="relative flex flex-col items-start gap-6">
              <div className="relative w-28 h-28 rounded-full bg-white border border-bhyyve-border flex items-center justify-center shadow-[0_8px_30px_rgba(122,79,0,0.10)]">
                <span className="font-heading text-4xl font-bold text-bhyyve-honeyDeep">{step.num}</span>
                <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-bhyyve-honey ring-4 ring-bhyyve-subtle/40" />
              </div>
              <div>
                <h3 className="font-heading text-2xl sm:text-3xl font-medium text-bhyyve-ink mb-3 tracking-tight">{step.title}</h3>
                <p className="text-lg leading-relaxed text-bhyyve-muted max-w-sm">{step.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
